export enum ApplicationEventFilterAreaInteractionType {
  Open = 'open filter area',
  Close = 'close filter area',
  Apply = 'apply filter selection',
}
